module.exports = __webpack_public_path__ + "static/media/support1.31256fa7.webp";